export enum ActionType {
  RESET = '@@vp/RESET',
  LOGOUT = '@@vp/LOGOUT',
}
